import { PanelCard, SectionHeader } from '@renderer/shared/components/primitives';
import { useI18n } from '@renderer/shared/i18n';
import { AviConversationPanel } from './avi-conversation-panel';

export function AviScreen(): JSX.Element {
  const { t } = useI18n();

  return (
    <div className="av-page">
      <SectionHeader title={t('avi.title')} subtitle={t('placeholder.description')} />
      <PanelCard className="av-avi-panel" title={t('avi.title')}>
        <AviConversationPanel />
      </PanelCard>
    </div>
  );
}

